export class AccountType {
	id: number;
	name: string;
	fullTypeName: string;
}
